import { render, staticRenderFns } from "./add-class.vue?vue&type=template&id=01a52ddd&scoped=true&"
import script from "./add-class.vue?vue&type=script&lang=ts&"
export * from "./add-class.vue?vue&type=script&lang=ts&"
import style0 from "./add-class.vue?vue&type=style&index=0&id=01a52ddd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01a52ddd",
  null
  
)

component.options.__file = "add-class.vue"
export default component.exports